export default class RichGallery {
    constructor(element) {
        this.element = element;
        this.initializeDOM();

        if (this.thumbs.length > 0) {
            if (this.thumbs[0].getAttribute("data-type") === 'image') {
                this.showLargeImage(this.thumbs[0]);
            } else {
                this.showLargeVideo(this.thumbs[0]);
            }
        }
    }

    initializeDOM() {
        this.imageLarge = this.element.querySelector(".rich_gallery__large img");
        this.videoLarge = this.element.querySelector(".rich_gallery__large video");

        if (!this.imageLarge || !this.videoLarge) {
            throw "No large view in DOM";
        }

        this.imageLarge.addEventListener("load", () => {
            this.element.classList.remove("loading");
        })

        this.thumbs = this.element.querySelectorAll(".rich_gallery__thumbs__item");

        this.thumbs.forEach((asset) => {
            //for some reason the div with the gradient does not work with the thumbs because of the position absolute setting
            //so we add the gradient to the image instead.
            let gradient = asset.getAttribute("data-gradient");
            if (gradient !== null) {
                asset.classList.add(gradient);
            }

            asset.addEventListener("click", () => {
                if (asset.getAttribute("data-type") === 'image') {
                    this.showLargeImage(asset);
                } else {
                    this.showLargeVideo(asset);
                }

            });
        });
    }

    showLargeImage(thumb) {
        this.imageLarge.src = thumb.getAttribute("data-large");
        this.imageLarge.alt = thumb.alt;

        let gradient = thumb.getAttribute("data-gradient");

        if (gradient !== null) {
            this.imageLarge.parentElement.className = this.imageLarge.parentElement.className.replace(/gradient--\S+/g, '');
            this.imageLarge.parentElement.classList.add(gradient);
        } else {
            this.imageLarge.parentElement.className = 'rich_gallery__large';
        }

        this.imageLarge.style.display = 'block';
        this.videoLarge.style.display = 'none';
        this.videoLarge.pause();
        this.videoLarge.currentTime = 0;


        this.thumbs.forEach((asset) => {
            asset.parentElement.classList.remove("active");
            asset.parentElement.parentElement.classList.remove("active");

        });

        if (gradient !== null) {
            thumb.parentElement.parentElement.classList.add("active");
        } else {
            thumb.parentElement.classList.add("active");
        }

        this.element.classList.add("loading");
    }

    showLargeVideo(thumb) {
        this.imageLarge.style.display = 'none';
        this.videoLarge.style.display = 'block';

        this.videoLarge.src = '/assets' + thumb.getAttribute("data-large");
        this.videoLarge.parentElement.className = "rich_gallery__large";

        this.thumbs.forEach((asset) => {
            asset.parentElement.classList.remove("active");
            asset.parentElement.parentElement.classList.remove("active");
        });


        thumb.parentElement.parentElement.classList.add("active");
    }
}